// extracted by mini-css-extract-plugin
module.exports = {"market-status":"_1IdjmWnQkk_sDC6OK8ocrq","dot":"_2H2hYSj6Y3oVpiABzE4pWo","is-open":"_1BJdyOd5I_FSASlda15CHw","is-loading":"_3frELKcgfwW41WJUYGSIUG"};